'use strict';

function getStatic(value) {
  return {
    tag: 'p',
    attrs: {
      className: {
        'form-control-static': true
      }
    },
    children: value
  };
}

module.exports = getStatic;


/*****************
 ** WEBPACK FOOTER
 ** ./~/uvdom-bootstrap/lib/getStatic.js
 ** module id = 1076
 ** module chunks = 0
 **/